// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FilterChip__container-eff66b {
  --input-chips-item-background-color: var(--base-20);
  --input-chips-item-color: var(--base-110);
  --input-chips-item-height: 40px;
  background-color: var(--input-chips-item-background-color);
  color: var(--input-chips-item-color);
  max-height: var(--input-chips-item-height);
  width: 60px;
  border-radius: 100px;
  padding: 8px 12px;
  cursor: pointer;
  user-select: none;
  font: var(--font-body-3);
  letter-spacing: var(--font-spacing-body-3);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.FilterChip__container-eff66b:hover,
.FilterChip__container-eff66b:focus {
  --input-chips-item-background-color: var(--base-30);
}

.FilterChip__container-eff66b:active {
  --input-chips-item-background-color: var(--base-40);
}

.FilterChip__container-eff66b.FilterChip__disabled-f7d38c,
.FilterChip__container-eff66b.FilterChip__disabled-f7d38c:active,
.FilterChip__container-eff66b.FilterChip__disabled-f7d38c:focus,
.FilterChip__container-eff66b.FilterChip__disabled-f7d38c:hover {
  --input-chips-item-background-color: var(--base-10);
  --input-chips-item-color: var(--base-60);
  opacity: 0.5;
}

.FilterChip__container-eff66b.FilterChip__active-a86652 {
  --input-chips-item-color: var(--addition-50);
  --input-chips-item-background-color: var(--brand-primary-40);
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/RightSidebar/Form/Popup/FilterChip/FilterChip.styles.m.css"],"names":[],"mappings":"AAAA;EACE,mDAAA;EACA,yCAAA;EACA,+BAAA;EAEA,0DAAA;EACA,oCAAA;EACA,0CAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAAF;;AAGA;;EAEE,mDAAA;AAAF;;AAGA;EACE,mDAAA;AAAF;;AAGA;;;;EAIE,mDAAA;EACA,wCAAA;EACA,YAAA;AAAF;;AAGA;EACE,4CAAA;EACA,4DAAA;AAAF","sourcesContent":[".container {\n  --input-chips-item-background-color: var(--base-20);\n  --input-chips-item-color: var(--base-110);\n  --input-chips-item-height: 40px;\n\n  background-color: var(--input-chips-item-background-color);\n  color: var(--input-chips-item-color);\n  max-height: var(--input-chips-item-height);\n  width: 60px;\n  border-radius: 100px;\n  padding: 8px 12px;\n  cursor: pointer;\n  user-select: none;\n  font: var(--font-body-3);\n  letter-spacing: var(--font-spacing-body-3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.container:hover,\n.container:focus {\n  --input-chips-item-background-color: var(--base-30);\n}\n\n.container:active {\n  --input-chips-item-background-color: var(--base-40);\n}\n\n.container.disabled,\n.container.disabled:active,\n.container.disabled:focus,\n.container.disabled:hover {\n  --input-chips-item-background-color: var(--base-10);\n  --input-chips-item-color: var(--base-60);\n  opacity: 0.5;\n}\n\n.container.active {\n  --input-chips-item-color: var(--addition-50);\n  --input-chips-item-background-color: var(--brand-primary-40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FilterChip__container-eff66b`,
	"disabled": `FilterChip__disabled-f7d38c`,
	"active": `FilterChip__active-a86652`
};
module.exports = ___CSS_LOADER_EXPORT___;
